<script>
import axios from 'axios';
import { cmsUrl } from '../variables';
import { escapeHtml } from '../helpers';

import ContentTextBlock from '../components/ContentTextBlock';
import ContentAdviceBlock from '../components/ContentAdviceBlock';
import LoadIndicator from '../components/LoadIndicator';
import ContentGoodToKnowBlock from '../components/ContentGoodToKnowBlock';
import ContentLinkBlock from '../components/ContentLinkBlock';
import ContentEmergencyButtonBlock from '../components/ContentEmergencyButtonBlock';

export default {
    name: 'ArticlePage',
    components: {
        LoadIndicator,
        ContentTextBlock,
        ContentAdviceBlock,
        ContentGoodToKnowBlock,
        ContentLinkBlock,
        ContentEmergencyButtonBlock,
    },
    props: {
        slug: String,
    },
    data() {
        return {
            pageData: null,
            error: null,
            isLoading: true,
            linksToCloseOverlay: [],
        }
    },
    metaInfo() {
        if (this.pageData) {
            let meta = [
                { vmid: 'og:url', property: 'og:url', content: this.$t('global.url') + window.location.pathname }
            ];
            if (this.pageData.description) {
                meta.push({ vmid: 'description', name: 'description', content: this.pageData.description })
                meta.push({ vmid: 'og:description', property: 'og:description', content: this.pageData.description })
            }
            if (this.pageData.title)
                meta.push({ vmid: 'og:title', property: 'og:title', content: escapeHtml(this.pageData.title.rendered) });
            if (this.pageData.preview_img)
                meta.push({ vmid: 'og:image', property: 'og:image', content: this.pageData.preview_img });
            
            return {
                titleTemplate: this.pageData.seo_title ? this.pageData.seo_title : escapeHtml(this.pageData.title.rendered),
                link: [
                    { vmid: 'canonical', rel: 'canonical', href: this.$t('global.url') + window.location.pathname }
                ],
                meta: meta,
            }
        }
    },
    mounted() {
        this.$store.dispatch('setSiteHeaderOpaque');
        this.$store.dispatch('showSiteFooter');
        this.init(this.$route.params.slug);
    },
    methods: {
        init(slug) {
            axios
                .get(cmsUrl + '/articles/?slug=' + slug)
                .then(this.onDataLoaded)
                .catch(err => { this.error = err; this.isLoading = false;})
        },
        onDataLoaded(data) {
            this.pageData = data.data.length > 0 ? data.data[0] : null;
            this.isLoading = false;
        },
        getComponentName(layout) {
            switch (layout) {
                case 'text_block':
                    return 'ContentTextBlock';

                case 'advice':
                    return 'ContentAdviceBlock';

                case 'good_to_know':
                    return 'ContentGoodToKnowBlock';

                case 'link_block':
                    return 'ContentLinkBlock';

                case 'emergency_button':
                    return 'ContentEmergencyButtonBlock';

            }
        },
    },
    beforeRouteUpdate(to, from, next) {
        this.init(to.params.slug);
        next();
    },
};
</script>

<template>
    <section class="article-page" v-bind:class="['article-page--' + $route.params.pageName]">
        <div class="article-page__wrapper">
            <div v-if="!isLoading && pageData">

                <div class="article-page__title-wrap">
                    <router-link
                        v-bind:to="'/' + $t('articles.archiveUrl')"
                        class="article-page__overview-link">
                    </router-link>
                    <h1 class="article-page__title page-title" v-html="pageData.title.rendered"></h1>
                    <p class="article-page__lead page-lead">{{ pageData.lead }}</p>
                </div>

                <component 
                    v-for="(block, i) in pageData.content_blocks" 
                    v-bind:key="i"
                    v-bind:data="block"
                    v-bind:is="getComponentName(block.acf_fc_layout)">
                </component>

            </div>

            <load-indicator v-if="isLoading" />

        </div>
    </section>
</template>

<style lang="scss">
.article-page {
    @include page;
}

.article-page__wrapper {
    @include container-narrow;
}

.article-page__title-icon--consulting,
.article-page__title-icon--triological {
    width: 13.6rem;
    height: 12.9rem;
    margin: 0 0 1.4rem -3.2rem;
    background-size: 100%;
    background-repeat: no-repeat;

    @include breakpoint('md-down') {
        margin-left: 0;
    }
}

.article-page__title-icon--consulting {
    background-image: url('~@/assets/images/logo-consulting.svg');
}

.article-page__title-icon--triological {
    background-image: url('~@/assets/images/logo-triological.svg');
}

.article-page__title-wrap {
    position: relative;
}

.article-page__overview-link {
  position: absolute;
  display: block;
  top: -0.96rem;
  left: -12rem;
  width: 5.6rem;
  height: 4.8rem;
  margin: 0;
  padding: 1.28rem 0;
  background: center url('~@/assets/images/ico-back-overview.svg') no-repeat
    transparent;
  cursor: pointer;
  z-index: 1;
  transition: transform 200ms;

  @include breakpoint('sm-down') {
    top: -5.12rem;
    left: 0rem;
    width: 3.36rem;
    height: 2.08rem;
    background-size: 3.36rem;
  }

  @include breakpoint('md-up') {
    &:hover {
      transform: translateX(-0.8rem);
    }
  }
}

</style>
